import { Pipe, PipeTransform } from '@angular/core';
import { IngredientChoice } from 'ngx-web-api';

@Pipe({
  name: 'choiceIndex',
})
export class ChoiceIndexPipe implements PipeTransform {
  transform(choices: IngredientChoice[], choice: IngredientChoice): number {
    if (!!choices && choices.length > 0 && !!choice) {
      return choice && choice.name ? choices.map(ingredientChoice => ingredientChoice.name).indexOf(choice.name) : -1;
    }
    return -1;
  }
}
